import {
  BaseEditorState,
  Exchange,
  ExchangeChannel,
  TradingPair
} from "./common.types"

/** Editor state when editing requests meant for the spot API */
export interface SpotEditorState extends BaseEditorState<"spot"> {
  event: "subscribe"
  channel: ExchangeChannel
  symbol: TradingPair
  exchange: Exchange
  duration: number
  refundInvoice: string
}

/** Given an invoice, returns the default editor state for each channel */
export const DefaultSpotRequestsForChannel: (
  refundInvoice: string
) => { [key in ExchangeChannel]: SpotEditorState } = refundInvoice => ({
  books: {
    api: "spot",
    event: "subscribe",
    channel: "books",
    symbol: "BTCUSD",
    exchange: "bitfinex",
    duration: 120000,
    refundInvoice
  },

  tickers: {
    api: "spot",
    event: "subscribe",
    channel: "tickers",
    symbol: "BTCUSDT",
    exchange: "binance",
    duration: 120000,
    refundInvoice
  },

  trades: {
    api: "spot",
    event: "subscribe",
    channel: "trades",
    symbol: "BTCUSD",
    exchange: "coinbase",
    duration: 120000,
    refundInvoice
  }
})
